/**
 * Accessibility hook for auto-focusing text elements
 * Ensures screen readers announce error messages and other important text
 */

import type { BoxRef } from '../../mads';

import { useEffect, type RefObject } from 'react';
import { AccessibilityInfo, findNodeHandle } from 'react-native';

export function useA11yAutoTextFocus(
    text: string | null | undefined,
    nodeRef: RefObject<BoxRef | null>,
) {
    useEffect(() => {
        let timer: number | null = null;

        if (nodeRef.current && text && text.length > 0) {
            timer = setTimeout(() => {
                const nativeNodeTag = findNodeHandle(nodeRef.current);
                if (nativeNodeTag) {
                    AccessibilityInfo.setAccessibilityFocus(nativeNodeTag);
                }
            }, 100); // Add a small delay to ensure the error message is rendered
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [text, nodeRef]);
}
